import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';
import { MatDialogModule } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatIconModule } from '@angular/material/icon';
import { EditGebaeudeDialogComponent } from './edit-gebaeude-dialog.component';

@NgModule({
  declarations: [ EditGebaeudeDialogComponent ],
  imports: [ 
    CommonModule, 
    ReactiveFormsModule, 
    MatDialogModule, 
    MatButtonModule, 
    MatFormFieldModule, 
    MatInputModule, 
    MatIconModule 
  ],
  exports: [ EditGebaeudeDialogComponent ]
})
export class EditGebaeudeDialogModule { }

